
<div v-if="$route.name === 'view_topic'">
                  <button class="btn btn-primary text-xs rounded-5 shadow mb-3" data-bs-toggle="modal"
                  data-bs-target="#feed_modal">Create Feed</button>

</div>
<div v-else-if="$route.name === 'customer_profile'">
  <button class="fab border-0 shadow mb-2 ms-3" data-bs-toggle="modal" data-bs-target="#feed_modal">+</button>
</div>

<!-- Otherwise, show full feed card -->
<div v-else-if="!cbo_domain" class="card border-0 rounded-5 shadow-sm mb-3" data-bs-toggle="modal" data-bs-target="#feed_modal"@click="fetch_portal_members">
  <div class="card-body p-3">
    <!-- Profile Section -->
    <div class="d-flex align-items-center">
      <div class="input-container flex-grow-1">
        <input type="text text-xxs"
               class="form-control bg-light border-0"
               placeholder="Write something ..."
               aria-label="Post content">
      </div>
    </div>
    <hr class="my-2 d-none d-sm-flex">
    <!-- Action Buttons -->
    <div class="d-flex justify-content-between d-none d-sm-flex">
      <span class="rounded-3 btn btn-light flex-grow-1 mx-1 d-flex align-items-center justify-content-center text-danger">
        <i class="bi bi-file-earmark-pdf action-icon"></i>
        <span class="text-xs ms-2 d-none d-md-inline">Document</span>
      </span>
      <span class="rounded-3 btn btn-light flex-grow-1 mx-1 d-flex align-items-center justify-content-center text-success">
        <i class="bi bi-images action-icon"></i>
        <span class="text-xs ms-2 d-none d-md-inline">Photo/video</span>
      </span>
      <span class="rounded-3 btn btn-light flex-grow-1 mx-1 d-flex align-items-center justify-content-center text-warning">
        <i class="bi bi-record-circle action-icon"></i>
        <span class="text-xs ms-2 d-none d-md-inline">Recordings</span>
      </span>
    </div>
  </div>
</div>


<!-- Feed Modal -->

<teleport to="body">
<div class="modal fade" id="feed_modal" tabindex="-1" aria-labelledby="createPostModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-lg modal-dialog-centered">
      <div class="modal-content rounded-5 shadow">
          <div class="modal-header">
              <h5 class="modal-title" id="createPostModalLabel">Create feed</h5>
              <button type="button" class="close-button" data-bs-dismiss="modal" aria-label="Close">
                <i class="bi bi-x fw-bold"></i>
              </button>
          </div>
          <form @submit.prevent="submit_form" class="p-2">
          <div class="post-content">
              <div class="user-info">
                  <div class="user-avatar">
                      <img src="@/assets/images/user.png" alt="User Avatar">
                  </div>
                  <div>
                      <div class="user-name mb-0">{{user_details.first_name}} {{user_details.last_name}}</div>
                      <div class="d-flex flex-row justify-content-between">
                        <div v-if="$route.name == 'publish_portal'" class="">

                          <span class="badge bg-primary text-xxs" data-bs-toggle="modal" data-bs-target="#category_modal" data-bs-dismiss="modal">Tag a category :</span>
                          <span v-for="cat in selected_categories" :key="cat.id" class="text-xxs ms-1 fw-bold">
                                {{ cat.name }},
                              </span>
                          </div>
                        <div v-if="$route.name !== 'view_portal' && $route.name !== 'view_topic' && $route.name !== 'publish_portal'">
                          <select class="text-xxs border-0 rounded-3 border-end form-select-sm bg-gray"
                          v-model="selectedPortalId" @change="onPortalChange" id="portals">
                          <option value="" selected hidden>
                            * Tag a portal
                          </option>
                          <option v-for="portal in portals" :value="portal.id" :key="portal.id">{{ portal.name }}</option>
                        </select>
                        <p v-if="errors.portal" class="text-danger text-xs">{{ errors.portal }}</p>
                          </div>
                        <div v-if="topics.length > 0">
                          <select class="form-select-sm mx-2 bg-gray fw-500 border-0 rounded-3 text-xxs"
                            v-model="selectedTopicId" id="topic">
                            <option value="" selected hidden>Tag a segment</option>
                            <option v-for="topic in topics" :value="topic.id" :key="topic.id">
                              {{ topic.name }}
                            </option>
                          </select>
                        </div>
                    </div>
                      
                      </div>
              </div>




              <div class="textarea-container">
                <div id="quillEditor" class="quill-editor" ref="quillReportEditorRef"></div>
                <div v-if="showSuggestions && filteredUsers.length > 0" class="suggestions-dropdown modal-body-scroll">
                  <div v-for="user in filteredUsers" 
                       :key="user.id" 
                       class="suggestion-item"
                       @mousedown="selectUser(user)">
                    {{ user.full_name }}
                  </div>
                </div>

                <div v-if="fileName" class="text-xs text-secondary fst-italic mt-1">
                  <span class="fw-500">File name:</span> {{ fileName }}
                </div>
                <div v-if="fileError" class="text-xs text-danger fst-italic mt-1">{{ fileError }}</div>

           

                <div v-if="imagePreview" class="mt-2">
                  <img :src="imagePreview" alt="Preview" class="img-fluid rounded" style="max-width: 200px; max-height: 200px;" />
                </div>
              </div>
              <div v-if="errors.report_description" class="error-message">
                {{ errors.report_description }}
              </div>
             </div>
          <div class="add-to-post d-flex align-items-center justify-content-between">
              <div class="add-to-post-text">Add to your feed</div>
              <div class="d-flex flex-row align-items-center">
                <label for="fileInput" class="file-upload post-option"><i class="bi bi-images icon-photo"></i>/<i class="bi bi-filetype-docx icon-more"></i></label>
                <input type="file" id="fileInput" class="file-input d-none" @change="handleFileUpload" />
                <label for="audioInput" class="post-option"> <i class="bi bi-music-note-beamed icon-emoji"></i></label>
                <input type="file" accept="audio/*" id="audioInput" class="file-input d-none" @change="handleAudioUpload" />
                <div v-if="audioError" class="text-xs text-danger fst-italic mt-1">{{ audioError }}</div>    
                <button class="post-option" @click="startRecording" v-if="!isRecording">
                  <i class="bi bi-mic icon-location"></i>
                </button>
                <button class="post-option" @click="stopRecording" v-if="isRecording">
                  <i class="bx bx-stop icon-location"></i>
                </button>
              </div>    
          </div>
          <div class="post-button-container">
            <p v-if="errors.report_details" class="text-danger text-xs">{{ errors.report_details }}</p>
              <button class="btn btn-primary w-100 rounded-3 shadow-sm" type="submit">Post</button>
          </div>
        </form>
      </div>
  </div>
</div>
</teleport>

<div class="modal fade" id="category_modal" tabindex="-1" aria-labelledby="category_modal_label" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content border-0 rounded-5 shadow-sm">
      <div class="modal-header">
        <h6 class="modal-title" id="category_modal_label">Select a Category</h6>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
             <div
                v-for="category in grouped_tags"
                :key="category.id"
                class="col-md-6"
              >
                <label class="form-label fw-bold mb-1 text-xxs">{{ category.name }}</label>
                <select
                  class="form-select form-select-sm bg-light border rounded text-xxs mb-2"
                  v-model="selected_tags[category.name]"
                >
                  <option :value="null" disabled selected>Select {{ category.name }}</option>
                  <option
                    v-for="tag in category.tags"
                    :value="tag.id"
                    :key="tag.id"
                  >
                    {{ tag.name }}
                  </option>
                </select>
              </div>
      </div>
      <div class="text-end">
        <button type="button" class="btn btn-primary btn-sm text-xxs rounded-3 shadow-sm m-3" @click="submit_tags" data-bs-toggle="modal"
                  data-bs-target="#feed_modal" data-bs-dismiss="modal">Save</button>
      </div>
    </div>
  </div>
</div>